<template>
  <div class="container" style="overflow: auto;height: 100vh;" ref="wrap">
    <div style="padding-top: 16em; padding-bottom: 23em;">
      <SiteItem v-for="item in saleList"
                :item="item"
                :isAdmin="true"
                :show-btn="true"
                @remove="onRemove"
      >
      </SiteItem>
    </div>
  </div>
</template>
<script>
import SiteItem from "../../../controls/SiteItem";
import Utils from "../../../../config/utils";
import store from "../../../../config/store";
export default {
  name: "AdminWriteSale",
  components: {
    SiteItem
  },
  props:["phone"],

  data() {
    return {
      sale_filter: '',
      sale_order: 'asc',
      saleList:[],
      salePageNum:1,
    }
  },
  methods:{
    handleScroll(){
      let wrap = this.$refs.wrap;
      if(wrap.scrollHeight - wrap.scrollTop === wrap.clientHeight){ //end of scroll
        this.getList(false);
      }
    },

    onRemove(idx) {
        this.saleList =  this.saleList.filter(it => {
          return it.f_idx != idx;
        });
    },

    getList(clear = false) {
      console.log("----------------- getList\n");
      console.log("----------------- this.sale_filter: ", this.sale_filter);
      let saleLoadingEnd;

      if (clear) {
          this.salePageNum = 1;
          saleLoadingEnd =  false
      }
      if (saleLoadingEnd) {
        return;
      }

      if (this.$store.getters.isLoading) {
        return;
      }

      Utils.requestGet(
        this.$c.API.Site.findSiteListByName,
        {
          search_key: this.phone,
          page_num: this.salePageNum,
          filter: this.sale_filter,
          order: this.sale_order
        },
      ).then(result => {

        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.saleLoadingEnd = result.data.count > result.data.list.length;
            this.salePageNum = ++this.salePageNum;
            this.saleList = clear ? result.data.list : this.saleList.concat(result.data.list);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.$refs.wrap.onscroll = this.handleScroll;
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/_vars.scss';
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminWriteSale.vue